import React, { useState } from "react";
import { Box, Typography, Divider, Collapse, IconButton } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ShoppingListItemCard from "./ShoppingListItemCard";

const SupplierGroup = ({
  supplier,
  items,
  onStatusChange,
  onDelete,
  defaultOpen = true,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  // 🔁 Group items by storePathIndex
  const groupedByPathIndex = items.reduce((acc, item) => {
    console.log(item);
    const pathIndex =
      item.supplyItemId?.storePathIndex ??
      item.ingredientId?.storePathIndex ??
      item.storePathIndex ?? // fallback for legacy
      "unassigned";

    if (!acc[pathIndex]) acc[pathIndex] = [];
    acc[pathIndex].push(item);
    return acc;
  }, {});

  // 🔢 Sort group keys numerically, with unassigned last
  const sortedGroups = Object.entries(groupedByPathIndex).sort(([a], [b]) => {
    const aNum = a === "unassigned" ? 999 : Number(a);
    const bNum = b === "unassigned" ? 999 : Number(b);
    return aNum - bNum;
  });

  return (
    <Box sx={{ mb: 4 }}>
      {/* Supplier heading */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
        <Typography variant="subtitle1" fontWeight="bold">
          {supplier}
        </Typography>
        <IconButton onClick={() => setOpen(!open)}>
          {open ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Box>

      <Divider sx={{ mb: 1 }} />

      {/* Collapsible content */}
      <Collapse in={open} timeout="auto" unmountOnExit>
        {sortedGroups.map(([section, sectionItems]) => (
          <Box key={section} sx={{ mb: 3 }}>
            <Typography
              variant="subtitle2"
              fontWeight={600}
              sx={{ mb: 1 }}
              color={section === "unassigned" ? "error.main" : "text.primary"}>
              {section === "unassigned"
                ? "⚠️ Unassigned Section"
                : `🟦 Section ${section}`}
            </Typography>

            {sectionItems.map((item) => (
              <ShoppingListItemCard
                key={item._id}
                item={item}
                onStatusChange={(update) => onStatusChange(item._id, update)}
                onDelete={(id) => onDelete(id)}
              />
            ))}
          </Box>
        ))}
      </Collapse>
    </Box>
  );
};

export default SupplierGroup;
